"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormModalCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var log_service_1 = require("../../services/log.service");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var CollectionFormModalCtrl = /** @class */ (function () {
    function CollectionFormModalCtrl(collections) {
        this.collectionStats = [];
        this.failures = [];
        this.updatingForm = false;
        this.collections = collections;
    }
    CollectionFormModalCtrl.prototype.updateFormCollections = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var outputs, _loop_1, _i, _a, stat, state_1, newCollectionUuids, _b, outputs_1, newCollection, savedCollection;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.setUpdatingForm(true);
                        outputs = [];
                        _loop_1 = function (stat) {
                            var formModel, collectionModel, upgrade, output;
                            return tslib_1.__generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (!stat.latestFormRevision) {
                                            return [2 /*return*/, { value: void 0 }];
                                        }
                                        if (stat.actualFormRevision === stat.latestFormRevision) {
                                            return [2 /*return*/, "continue"];
                                        }
                                        return [4 /*yield*/, store_1.AppStore.Form.fetch(stat.latestFormRevision)];
                                    case 1:
                                        formModel = _d.sent();
                                        return [4 /*yield*/, store_1.AppStore.Collection.fetch(stat.collectionRevision)];
                                    case 2:
                                        collectionModel = _d.sent();
                                        upgrade = core_shared_1.IkeModel.Collection.upgrade([collectionModel], formModel);
                                        return [4 /*yield*/, upgrade.process(log_service_1.Logger)];
                                    case 3:
                                        output = _d.sent();
                                        if (output.result !== 'success') {
                                            output.fields.forEach(function (field) {
                                                _this.failures.push({
                                                    failure: field,
                                                    collectionId: stat.collectionId,
                                                    collectionTitle: stat.collectionTitle
                                                });
                                            });
                                        }
                                        else {
                                            outputs.push(output.collections[0]);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _i = 0, _a = this.collectionStats;
                        _c.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        stat = _a[_i];
                        return [5 /*yield**/, _loop_1(stat)];
                    case 2:
                        state_1 = _c.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (this.failures.length > 0) {
                            throw new Error((0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_ERROR));
                        }
                        newCollectionUuids = [];
                        _b = 0, outputs_1 = outputs;
                        _c.label = 5;
                    case 5:
                        if (!(_b < outputs_1.length)) return [3 /*break*/, 8];
                        newCollection = outputs_1[_b];
                        return [4 /*yield*/, this.saveCollection(newCollection)];
                    case 6:
                        savedCollection = _c.sent();
                        newCollectionUuids.push(savedCollection.uuid);
                        _c.label = 7;
                    case 7:
                        _b++;
                        return [3 /*break*/, 5];
                    case 8: return [4 /*yield*/, page_state_1.CurrentState.updateInspectedCollection()];
                    case 9:
                        _c.sent();
                        return [4 /*yield*/, this.refresh(newCollectionUuids)];
                    case 10:
                        _c.sent();
                        this.setUpdatingForm(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionFormModalCtrl.prototype.saveCollection = function (newCollection) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newCollectionJsonSave, rest, savedCollection;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newCollectionJsonSave = core_shared_1.IkeModel.Collection.write(newCollection);
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.save(rest.Objects.Collection, newCollectionJsonSave)];
                    case 1:
                        savedCollection = _a.sent();
                        return [2 /*return*/, savedCollection];
                }
            });
        });
    };
    CollectionFormModalCtrl.prototype.refresh = function (collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionSummaries;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(collectionUuids.map(function (uuid) { return store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch(); }))];
                    case 1:
                        collectionSummaries = _a.sent();
                        return [2 /*return*/, Promise.all(tslib_1.__spreadArray([
                                store_1.AppStore.Tag.refresh()
                            ], this.getTagIds(collectionSummaries).map(function (tagId) { return store_1.AppStore.TagSummary.getFetchable(tagId).refetch(); }), true))];
                }
            });
        });
    };
    CollectionFormModalCtrl.prototype.getTagIds = function (collectionSummaries) {
        var tags = {};
        for (var _i = 0, collectionSummaries_1 = collectionSummaries; _i < collectionSummaries_1.length; _i++) {
            var collectionSummary = collectionSummaries_1[_i];
            for (var _a = 0, _b = collectionSummary.tags; _a < _b.length; _a++) {
                var tag = _b[_a];
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    };
    CollectionFormModalCtrl.prototype.setUpdatingForm = function (updatingForm) {
        this.updatingForm = updatingForm;
    };
    CollectionFormModalCtrl.prototype.getCollectionStats = function (departmentForms) {
        var collectionStats = [];
        this.collections.forEach(function (collectionSummary) {
            var formSummary = store_1.AppStore.FormSummary.get(collectionSummary.formRevision);
            var stat = {
                collectionId: collectionSummary.collectionId,
                collectionTitle: collectionSummary.title,
                collectionRevision: collectionSummary.revision,
                formUuid: formSummary ? formSummary.uuid : '',
                actualFormRevision: collectionSummary.formRevision,
                actualFormDate: formSummary ? formSummary.updatedAt : ''
            };
            collectionStats.push(stat);
        });
        collectionStats.forEach(function (stat) {
            var form = stat.formUuid ? departmentForms.find(function (_a) {
                var uuid = _a.uuid;
                return uuid === stat.formUuid;
            }) : null;
            if (form) {
                stat.latestFormRevision = form.revision;
                stat.latestFormName = form.displayname;
                stat.latestFormDate = form.updatedAt;
            }
        });
        this.collectionStats = collectionStats;
        return collectionStats;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionFormModalCtrl.prototype, "tagName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionFormModalCtrl.prototype, "updatingForm", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionFormModalCtrl.prototype, "setUpdatingForm", null);
    return CollectionFormModalCtrl;
}());
exports.CollectionFormModalCtrl = CollectionFormModalCtrl;
//# sourceMappingURL=collection.form.modal.ctrl.js.map